import React, { useEffect } from "react";

export default function LinkedInSuccessPage() {
  useEffect(() => {
    // Close this popup window — the parent page is polling and will detect the connection
    const timer = setTimeout(() => {
      window.close();
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-4">
      <div className="card p-8 text-center max-w-sm">
        <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-lg font-display font-semibold text-ink tracking-tight mb-2">
          LinkedIn connecté
        </h2>
        <p className="text-sm text-mute">
          Cette fenêtre va se fermer automatiquement.
        </p>
        <button
          onClick={() => window.close()}
          className="btn-primary mt-4 text-sm"
        >
          Fermer
        </button>
      </div>
    </div>
  );
}
